import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {ConfigurationModel} from '../../models/configuration.model';

@Component({
    selector: 'app-add-transport',
    templateUrl: './add-transport.page.html',
    styleUrls: ['./add-transport.page.scss'],
})
export class AddTransportPage implements OnInit {

    @Input() document: DocumentModel;
    transports: DetaillineDTOModel[];
    transport: DetaillineDTOModel;
    showInput = false;

    constructor(public modalController: ModalController,
                private loki: LokijsService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames) {
    }

    ngOnInit() {
        this.transports = this.loki.getTable('producttype', '$loki').chain().find({transportProductType: true}).data();
        for (const transport of this.transports) {
            transport.comment = transport.description;
        }
        this.transport = new DetaillineDTOModel();
    }

    selectTransport(event) {
        this.transport = event.detail.value;
        // The comment is used as description due to backend
        this.transport.total = this.transport.currentSellPrice;
        this.transport.weeklyRate = this.transport.currentSellPrice;
    }

    addTransports() {
        const configuration = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION) as ConfigurationModel;
        if (this.transport.plu) {
            this.transport.weeklyRate = this.transport.total;
            this.transport.qty = configuration.chargeDeliveryAndCollection ? 2 : 1;
            this.transport.discount = 0;
            console.log(this.transport);
            this.document.detailLines.push(this.transport);
        }
        this.modalController.dismiss();
    }
}
